import { createMocks } from '@backbase/foundation-ang/data-http';
import { Provider } from '@angular/core';

/**
 * Mocks provider for /contact-aux-service/v2/contact URL pattern
 */
export const ContactsHttpServiceGetContactByTypeIdMocksProvider: Provider = createMocks([
  {
    urlPattern: '/contact-aux-service/v2/contact',
    method: 'POST',
    responses: [
      {
        status: 200,
        body: {
          name: 'Consulta de impuestos de transacciones',
          $ref: 'examples/body/contactauxservice_response.json',
        },
      },
      {
        status: 200,
        body: {
          ContactType: { TypeId: 'CIP', IdContact: '00104105176' },
          ContactInformation: { Nombre: 'NELSON HENRIQUEZ CELEDONIO' },
        },
      },
    ],
  },
]);

export const ContactsHttpServiceMocksProvider: Provider = createMocks([
  {
    urlPattern: '/contact-aux-service/v2/contact',
    method: 'POST',
    responses: [
      {
        status: 200,
        body: {
          ContactType: {
            TypeId: 'Cédula ó RNC',
            IdContact: '01140153360',
          },
          ContactInformation: {
            Nombre: 'Markus Garza',
          },
        },
      },
    ],
  },
]);
